
  import vercelRuntime$DURA3w36tVJ0DkH56wm70Nz4S7WxJbsSJXOSwClr9RY from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 320,
    "xsm": 480
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "firebasestorage.googleapis.com",
    "storage.googleapis.com",
    "localhost",
    "127.0.0.1",
    "mulberry-one.vercel.app",
    "mulberryss.shop"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"vercel"} */
    provider: "vercel",
    providers: {
        ['vercel']: { setup: vercelRuntime$DURA3w36tVJ0DkH56wm70Nz4S7WxJbsSJXOSwClr9RY, defaults: {} }
    }
  }
